module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/about_us-b69b6de4185d4993fbe6dddebeab8372.jpg";